export interface TagChip {
  id: number;
  label: string;
  color: string | null;
}

export interface TagChipsProps {
  tags: TagChip[];
  emptyLabel?: string;
  onRemove?: (tag: TagChip) => void;
}

export function TagChips({ tags, emptyLabel = 'No tags yet.', onRemove }: TagChipsProps) {
  if (tags.length === 0) {
    return <span className="text-muted-foreground text-xs italic">{emptyLabel}</span>;
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className="inline-flex items-center gap-1.5 rounded-full border border-border/50 bg-card px-2.5 py-1 text-[11px] font-medium text-foreground"
        >
          <span
            className="h-1.5 w-1.5 rounded-full shrink-0"
            style={{ backgroundColor: tag.color || '#94a3b8' }}
          />
          {tag.label}
          {onRemove && (
            <button
              type="button"
              onClick={() => onRemove(tag)}
              className="ml-0.5 text-muted-foreground hover:text-destructive"
              aria-label={`Remove ${tag.label}`}
            >
              ×
            </button>
          )}
        </span>
      ))}
    </div>
  );
}
